import { createAction, props } from '@ngrx/store';
import { Dataset, DatasetReferenceDto, DatasetReferenceTable, DatasetsDto } from 'src/app/services/models/datasets.models';
import { FilterBar } from 'src/app/services/models/filter-bar.model';
import { Filter } from 'src/app/services/models/filter.model';
import { MetricDto } from 'src/app/services/models/metric.models';
import { UserBoard } from 'src/app/services/models/user-board.model';


///BOARD COLORS
export const loadBoardColors = createAction(
  '[BoardState] Load BoardColors'
);

export const loadBoardColorsSuccess = createAction(
  '[BoardState] Load BoardColors Success',
  props<{ colors: string[] }>()
);

export const loadBoardColorsFailure = createAction(
  '[BoardState] Load BoardColors Failure',
  props<{ error: any }>()
);


///DATASETS
export const loadDatasetsSuccess = createAction(
  '[BoardState] Load Datasets Success',
  props<{ datasets: Map<number, Dataset> }>()
);

export const loadDatasetsFailure = createAction(
  '[BoardState] Load Datasets Failure',
  props<{ error: any }>()
);

export const updateDatasetSuccess = createAction(
  '[BoardState] Update Dataset Success',
  props<{ dataset: Dataset }>()
);

export const deleteDatasetSuccess = createAction(
  '[BoardState] Delete Dataset Success',
  props<{ datasetId: number }>()
);

export const clearDatasets = createAction(
  '[BoardState] Clear Datasets'
);

///User Boards
export const loadUserBoardSuccess = createAction(
  '[BoardState] Load UserBoard Success',
  props<{ userBoards: UserBoard[] }>()
);

export const loadUserBoardFailure = createAction(
  '[BoardState] Load UserBoard Failure',
  props<{ error: any }>()
);

export const updateUserBoardSuccess = createAction(
  '[BoardState] Update UserBoard Success',
  props<{ userBoard: UserBoard }>()
);

export const deleteUserBoardSuccess = createAction(
  '[BoardState] Delete UserBoard Success',
  props<{ userBoardId: string }>()
);

export const clearUserBoard = createAction(
  '[BoardState] Clear UserBoard'
);


///Filters
export const loadFilterSuccess = createAction(
  '[BoardState] Load Filters Success',
  props<{ filters: Filter[] }>()
);

export const loadFilterFailure = createAction(
  '[BoardState] Load Filters Failure',
  props<{ error: any }>()
);

export const updateFilterSuccess = createAction(
  '[BoardState] Update Filters Success',
  props<{ filter: Filter }>()
);

export const deleteFilterSuccess = createAction(
  '[BoardState] Delete Filter Success',
  props<{ filterId: string }>()
);

export const clearFilters = createAction(
  '[BoardState] Clear Filters'
);


///Filter Bars
export const loadFilterBarSuccess = createAction(
  '[BoardState] Load FilterBars Success',
  props<{ filterBars: FilterBar[] }>()
);

export const loadFilterBarFailure = createAction(
  '[BoardState] Load FilterBars Failure',
  props<{ error: any }>()
);

export const updateFilterBarSuccess = createAction(
  '[BoardState] Update FilterBars Success',
  props<{ filterBar: FilterBar }>()
);

export const deleteFilterBarSuccess = createAction(
  '[BoardState] Delete FilterBar Success',
  props<{ filterBarId: string }>()
);

export const clearFilterBars = createAction(
  '[BoardState] Clear FilterBars'
);

///METRICS
export const loadMetricListSuccess = createAction(
  '[BoardState] Load Metrics List Success',
  props<{ metrics: Map<number, MetricDto> }>()
);

export const loadMetricListFailure = createAction(
  '[BoardState] Load Metrics List Failure',
  props<{ error: any }>()
);

export const updateMetricSuccess = createAction(
  '[BoardState] Update Metric Success',
  props<{ metric: MetricDto }>()
);

export const deleteMetricSuccess = createAction(
  '[BoardState] Delete Metric Success',
  props<{ metricId: number }>()
);

export const clearMetrics = createAction(
  '[BoardState] Clear Metrics'
);
